import React, { useState } from 'react';
import useTranslation from '../../../../Hooks/useTranslation';
import Modal from '../../../../Components/Modal/Modal';
import NCZISetupModalContent from './NCZISetupModalContent';
import Button from '../../../../Components/Button/Button';
import { Size } from '../../../../Enums/Size.enum';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';
import NCZIWizardModal from '../NCZIWizard/NCZIWizardModal';

interface Props {}

const NCZISetupModal: React.FC<Props> = props => {
	const { t } = useTranslation();
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const [settingsOpen, setSettingsOpen] = useState<boolean>(false);
	const [instructionsModalOpen, setInstructionsModalOpen] = useState<boolean>(false);
	const { isAllowed } = useAclContext();

	if(!isAllowed('ezdravie_setup')) {
		return (
			<></>
		);
	}

	return (
		<div>
			<Button
				onClick={() => setModalOpen(true)}
				title={t('component.nczi.setup.button')}
				theme={'blue'}
				className={'mt-4'}
			/>
			<Modal
				opened={modalOpen}
				onClose={() => {
					setModalOpen(false);
					setSettingsOpen(false);
				}}
				fullScreen={false}
				size={Size.MD}>
				<Modal.Header title='component.nczi.setup.button' />
				<Modal.Content>
					{settingsOpen ? <>
						<NCZISetupModalContent onClose={() => setSettingsOpen(false)} />
					</> : <>
						<Button
							onClick={() => { setModalOpen(false); setInstructionsModalOpen(true); }}
							title={t('component.nczi.setupInstructions.button')}
							theme={'blue'}
							className={'mt-4'}
						/>
						<Button
							onClick={() => setSettingsOpen(true)}
							title={t('component.nczi.setupOnlySettings.button')}
							theme={'blue'}
							className={'mt-4'}
						/>
					</>}
				</Modal.Content>
			</Modal>
			<NCZIWizardModal isOpen={instructionsModalOpen} onClose={() => setInstructionsModalOpen(false)} />
		</div>
	);
};

export default NCZISetupModal;
